module.exports = __webpack_public_path__ + "img/photo-23.1dab24f6.jpg";